<template>
  <v-app >
    <Header />
    <v-main class="flex-grow-1">
      <router-view></router-view>
    </v-main>
    <Footer />
  </v-app>
</template>

<script setup>
import { useRoute } from 'vue-router';
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { computed, ref, watch, provide } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
// const localeKey = computed(() => locale.value)


// 可以在这里导入其他组件或定义逻辑
</script>

<style>
/* 全局样式 */
.v-application {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.v-main {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

</style>